<template>
  <div>
    <!-- <JumpHeader /> -->
    <van-image class="cover-pic" :src="detail.pictureUrl" />
    <!-- <img class="cover-pic" :src="detail.pictureUrl" alt="" /> -->
    <div class="tab-wrapper" v-if="picTagList && picTagList.length">
      <ul class="tab-list">
        <li :class="['tab-item', currentTabIndex == 0 && 'tab-active']" @click="handleClickTab(0)">
          专题内容
        </li>
        <li :class="['tab-item', currentTabIndex == 1 && 'tab-active']" @click="handleClickTab(1)">
          专题图集
        </li>
      </ul>
    </div>

    <div class="content-wrapper">
      <div
        v-if="currentTabIndex == 0"
        :class="['content', currentTabIndex == 0 && 'content-active']"
      >
        <div class="tag-wrapper">
          <div
            class="tag-item"
            v-for="(item, index) in tagList"
            :key="index"
            @click="handleClickTagItem(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="page-wrapper">
          <div class="page-item" v-for="(item, index) in tagList" :key="index">
            <div class="item-title">
              <div class="title">
                <div class="tag-solid"></div>
                <span>{{ item.name }}</span>
              </div>
              <span class="more" @click="toCategory(item)">更多<van-icon name="arrow" /></span>
            </div>
            <div
              class="video-item"
              v-for="video in item.contentList"
              :key="video.id"
              @click="handleClickItem(video)"
            >
              <div class="left-side">
                <div class="left-title">{{ video.articleTitle }}</div>
                <div class="left-info">
                  <span class="time">{{ video.articleTime.split(" ")[0] }}</span>
                  <span class="name">{{ video.publishName }}</span>
                </div>
              </div>
              <div class="right-side">
                <img :src="video.pictureUrl" alt="" style="object-fit: cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="currentTabIndex == 1"
        :class="['content', currentTabIndex == 1 && 'content-active']"
      >
        <div class="img-wrapper">
          <div class="tag" v-for="(tag, tagIndex) in picTagList" :key="tagIndex">
            <div class="tag-head">
              <div class="tag-title">
                <div class="tag-solid"></div>
                <span>{{ tag.name }}</span>
              </div>
              <span class="tag-more" @click="handleClickImageMore"
                >更多<van-icon name="arrow"
              /></span>
            </div>
            <div class="tag-img" v-if="tag.pictures && tag.pictures.length">
              <div class="img" v-for="(img, imgIndex) in tag.pictures.slice(0, 2)" :key="imgIndex">
                <img @click="handleImageClick(img)" :src="img.url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-image-preview v-model="previewShow" :images="imagesLists" closeable> </van-image-preview>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { getTopicData, clickRecord, getTopicPictures, clickCountPictures } from "@/http/api";
import JumpHeader from "@/components/Base/JumpHeader";
import { Toast, Image as VanImage } from "vant";
import { getMobilsInfo } from "@/utils";

export default {
  name: "TopicDetail",
  components: {
    VanImage,
    JumpHeader,
  },
  data() {
    return {
      id: null,
      detail: {},
      tagList: [],
      currentTabIndex: 0,
      previewShow: false,
      imagesLists: [
        "https://gscb.kuaihd.com/mediadata/gzbn/product/src/2023/0322/thumb/9b54cffd99e94f56b3986960760527ca1375832388337664.jpg",
      ],
      picTagList: [],
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData();
    this.recordData();
    getTopicPictures({ id: this.id, operateType: 4 }).then((res) => {
      this.picTagList = res.data;
    });
  },
  methods: {
    async getData() {
      const { data } = await getTopicData({ id: this.id });
      this.detail = data;
      console.log(data);
      this.tagList = data.extendItem.tagList;
      this.wxShare();
      document.title = this.detail.title ? this.detail.title : "花城+";
    },
    async recordData() {
      await clickRecord({
        deviceId: "1",
        operateId: this.operateId,
        operateType: 1,
        web:1,
      });
    },
    handleClickImageMore() {
      Toast.fail("请先下载app");
    },

    handleClickItem(item) {
      if (item.operateType == 1) {
        // articleDetail
        this.$router.push({
          name: "articleDetail",
          query: {
            id: item.operateId,
          },
        });
      } else if (item.operateType == 4) {
        // window.open("https://share.gztv.com/plusshare/#/topicDetail?id="+item.operateId);
        this.$router.replace({ query: { id: item.operateId } });
        this.id = item.operateId;
        this.getData();
        this.recordData();
      } else if (item.operateType == 5) {
        // liveDetail
        this.$router.push({
          name: "liveDetail",
          query: {
            id: item.operateId,
          },
        });
      }  else if (item.operateType == 103) {
        window.open("https://share.gztv.com/plusfmshare/#/ColumnsDetail?id="+item.operateId);

      } else if (item.operateType == 2){
        // videoDetail
        this.$router.push({
          name: "videoDetail",
          query: {
            id: item.operateId,
          },
        });
      }
    },
    handleImageClick(img) {
      this.imagesLists = [img.url];
      this.previewShow = true;
      clickCountPictures(img.id);
    },
    toCategory(item) {
      this.$router.push({
        name: "topicTagDetail",
        query: {
          topicId: this.id,
          topicTag: item.name,
        },
      });
    },
    failToast() {
      Toast.fail("请先下载APP");
    },
    handleClickTagItem(item) {
      this.$router.push({
        name: "topicTagDetail",
        query: {
          topicId: this.id,
          topicTag: item.name,
        },
      });
    },
    wxShare() {
      const _detail = this.detail;
      wxSdk.getJSSDK({
        title: _detail.title,
        desc: _detail.intro,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/topicDetail?id=${_detail.id}`,
        img: `${process.env.VUE_APP_SHARE_URL}/filedata/default/hcplusIcon.jpg`,
        operateId: this.id,
        operateType: 4,
      });
    },
    handleClickTab(index) {
      this.currentTabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.cover-pic {
  width: 100%;
  height: 210px;
}
.tab-wrapper {
  padding: 0 15px;
  .tab-list {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 40px;
    list-style: none;
    padding: 0;
    margin: 0;

    .tab-item {
      font-size: 16px;
      line-height: 40px;
      color: #3c4455;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 10px;
      text-align: center;
      float: left;
      height: 40px;
      width: 50% !important;
      cursor: pointer;
      font-weight: bold;
      transition: background-color 0.3s, color 0.3s ease-in-out;
    }

    .tab-active {
      border-bottom: 2px solid #2993f0;
      color: #2993f0 !important;
    }
  }
}

.tag-wrapper {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;

  .tag-item {
    display: inline-block;
    padding: 3px 8px;
    color: #999;
    border: 1px solid #999;
    border-radius: 12px;
    font-size: 14px;
    margin-right: 8px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0px;
    }
  }
}

.img-wrapper {
  padding: 0 15px;
  .tag {
    margin-bottom: 13px;
    .tag-head {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: 15px 0;
      box-sizing: border-box;
      // padding: 0 15px;

      .tag-title {
        display: flex;
        align-items: center;
        .tag-solid {
          width: 4px;
          border-radius: 2px;
          height: 16px;
          background: #d93f30;
          margin-right: 3px;
        }
      }

      .tag-more {
        cursor: pointer;
        font-size: 12px;
      }
    }
    .tag-img {
      .img {
        width: calc(50% - 3px);
        height: 130px;
        margin-bottom: 6px;
      }
      margin-top: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }
    }
  }
}

.content-wrapper {
  display: flex;

  .content {
    flex: 0 0 100%;

    transform: translateX(100%);
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  .content-active {
    transform: translateX(0);
    opacity: 1;
  }
}

.page-wrapper {
  width: 100%;

  .page-item {
    width: 100%;

    .item-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: 15px 0;
      box-sizing: border-box;
      padding: 0 15px;

      .title {
        display: flex;
        align-items: center;
        font-size: 16px;

        .tag-solid {
          width: 4px;
          border-radius: 2px;
          height: 16px;
          background: #d93f30;
          margin-right: 3px;
        }
      }

      .more {
        font-size: 12px;
      }
    }

    .video-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      cursor: pointer;
      box-sizing: border-box;
      padding: 10px 15px;

      &:hover {
        background: #f9f9f9;
        border-radius: 8px;
      }

      .left-side {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        padding-right: 10px;
        height: 70px;

        .left-title {
          font-size: 16px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden; //溢出内容隐藏
          text-overflow: ellipsis; //文本溢出部分用省略号表示
          display: -webkit-box; //特别显示模式
          -webkit-line-clamp: 2; //行数
          line-clamp: 2;
          -webkit-box-orient: vertical; //盒子中内容竖直排列
        }

        .left-info {
          font-size: 10px;
          color: #999;

          .time {
            margin-right: 10px;
          }
        }
      }

      .right-side {
        & > img {
          width: 120px;
          height: 70px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
